<template>
    <v-container>
        <v-row no-gutters justify="center" align="center">
            <v-col cols="6" class="pl-12 pr-2">
                <v-card-title
                    class="justify-center align-center"
                    style="position: relative;"
                >
                    <v-btn
                        icon
                        @click="$router.back()"
                        class="mr-2 mt-3"
                        style="position: absolute; left: 0;"
                    >
                        <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>
                    {{ translations.createCompany[lang] }}
                </v-card-title>

                <v-form @submit.prevent="createCompany(lang)">
                    <v-card-text class="pt-0">
                        <v-row
                            v-if="
                                companyDetails.company_details
                                    .store_subscription_plan_id
                            "
                            no-gutters
                        >
                            <v-col cols="12">
                                <h4 class="subtitle-1 font-weight-bold mt-7">
                                    {{ translations.companyDetails[lang] }}
                                </h4>

                                <v-text-field
                                    v-model="
                                        companyDetails.company_details.name
                                    "
                                    :label="translations.companyName[lang]"
                                    color="secondary"
                                    clearable
                                    autocomplete="new-password"
                                    :success="success.name"
                                    :error-messages="error.name"
                                    @focus="error.name = ''"
                                    @blur="validateName"
                                ></v-text-field>

                                <v-select
                                    :items="countries"
                                    item-text="name"
                                    item-value="country_id"
                                    v-model="
                                        companyDetails.company_details
                                            .country_id
                                    "
                                    :label="translations.companyCountry[lang]"
                                    :success="success.companyCountry"
                                    :error-messages="error.companyCountry"
                                    @focus="error.companyCountry = ''"
                                    @change="validateCompanyCountry"
                                ></v-select>

                                <v-text-field
                                    v-model="
                                        companyDetails.company_details
                                            .vat_number
                                    "
                                    :label="translations.vatNumber[lang]"
                                    color="secondary"
                                    clearable
                                    autocomplete="new-password"
                                    :success="success.vatNumber"
                                    :error-messages="error.vatNumber"
                                    @focus="error.vatNumber = ''"
                                    @blur="validateVatNumber"
                                    :disabled="
                                        !companyDetails.company_details
                                            .country_id
                                    "
                                ></v-text-field>

                                <!-- <v-select
                                    :items="countries"
                                    item-text="name"
                                    item-value="country_id"
                                    v-model="
                                        companyDetails.company_details
                                            .vat_country_id
                                    "
                                    :label="translations.vatCountry[lang]"
                                    :success="success.vatCountry"
                                    :error-messages="error.vatCountry"
                                    @focus="error.vatCountry = ''"
                                    @blur="validateVatCountry"
                                ></v-select> -->

                                <v-text-field
                                    v-model="
                                        companyDetails.company_details.email
                                    "
                                    type="email"
                                    :label="translations.email[lang]"
                                    color="secondary"
                                    clearable
                                    autocomplete="new-password"
                                    :success="success.email"
                                    :error-messages="error.email"
                                    @focus="error.email = ''"
                                    @blur="validateEmail"
                                ></v-text-field>

                                <v-text-field
                                    v-model="
                                        companyDetails.company_details
                                            .primary_phone
                                    "
                                    v-mask="'##########'"
                                    :label="translations.primaryPhone[lang]"
                                    color="secondary"
                                    clearable
                                    autocomplete="off"
                                    :success="success.primaryPhone"
                                    :error-messages="error.primaryPhone"
                                    @focus="error.primaryPhone = ''"
                                    @blur="validatePrimaryPhone"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12">
                                <h4 class="subtitle-1 font-weight-bold mt-7">
                                    {{ translations.loyaltyDetails[lang] }}
                                </h4>

                                <v-text-field
                                    v-model="
                                        companyDetails.loyalty_details.name[
                                            nameLang
                                        ]
                                    "
                                    :label="translations.loyaltyName[lang]"
                                    :success="success.loyaltyName"
                                    :error-messages="error.loyaltyName"
                                    @focus="error.loyaltyName = ''"
                                    @blur="validateLoyaltyName"
                                >
                                    <template v-slot:append>
                                        <b-lang-menu
                                            v-model="nameLang"
                                            type="inner"
                                        ></b-lang-menu>
                                    </template>
                                </v-text-field>

                                <v-textarea
                                    v-model="
                                        companyDetails.loyalty_details
                                            .description[descriptionLang]
                                    "
                                    :label="
                                        translations.loyaltyDescription[lang]
                                    "
                                    :success="success.description"
                                    :error-messages="error.description"
                                    @focus="error.description = ''"
                                    @blur="validateDescription"
                                >
                                    <template v-slot:append>
                                        <b-lang-menu
                                            v-model="descriptionLang"
                                            type="inner"
                                        ></b-lang-menu>
                                    </template>
                                </v-textarea>

                                <!-- <v-select
                                    :items="countries"
                                    item-text="name"
                                    item-value="country_id"
                                    v-model="
                                        companyDetails.loyalty_details
                                            .country_id
                                    "
                                    :label="translations.loyaltyCountry[lang]"
                                    :success="success.loyaltyCountry"
                                    :error-messages="error.loyaltyCountry"
                                    @focus="error.loyaltyCountry = ''"
                                    @blur="validateLoyaltyCountry"
                                ></v-select> -->

                                <v-text-field
                                    v-model="
                                        companyDetails.loyalty_details
                                            .points_label
                                    "
                                    :label="translations.pointsLabel[lang]"
                                    color="secondary"
                                    clearable
                                    :success="success.pointsLabel"
                                    :error-messages="error.pointsLabel"
                                    @focus="error.pointsLabel = ''"
                                    @blur="validatePointsLabel"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-alert v-if="errorMessage" type="error">{{
                        errorMessage
                    }}</v-alert>

                    <v-card-actions>
                        <v-btn
                            type="submit"
                            color="secondary"
                            class="text-capitalize"
                            style="font-size: 1rem"
                            block
                            :loading="loading"
                            depressed
                            :disabled="!valid"
                        >
                            {{ translations.createCompany[lang] }}
                        </v-btn>
                    </v-card-actions>
                    <div
                        class="text-center mt-2 back-to-plan"
                        @click="
                            $router.push({
                                name: 'SubscriptionPlans',
                                params: { lang }
                            })
                        "
                    >
                        {{ translations.backToPlanSelection[lang] }}
                    </div>
                </v-form>
            </v-col>
            <v-col cols="5">
                <v-img
                    src="@/assets/register-image.png"
                    width="300"
                    class="mx-auto"
                ></v-img>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mdiAccount, mdiLock, mdiLockOutline, mdiEye } from "@mdi/js";
import { mapState, mapMutations, mapActions } from "vuex";
import validators from "@/utils/validators/loyaltyPanel/createCompany";
import translations from "@/utils/translations/register/createCompany";

export default {
    name: "CreateCompany",

    mixins: [validators, translations],

    data() {
        return {
            icons: { mdiAccount, mdiLock, mdiLockOutline, mdiEye },
            show: {
                password: false,
                confirmPassword: false
            },
            isAddress: false,
            nameLang: "en",
            descriptionLang: "en",
            changeNameElAuto: true,
            changeNameItAuto: true,
            changeDescriptionElAuto: true,
            changeDescriptionItAuto: true
        };
    },

    computed: {
        ...mapState("register", [
            "loading",
            "errorMessage",
            "companyDetails",
            "countries"
        ]),

        lang() {
            return this.$route.params.lang;
        },

        appProvider: {
            get() {
                return this.$store.state.register.appProvider;
            },

            set(val) {
                this.setAppProvider(val);
            }
        },

        fullname: {
            get() {
                return this.$store.state.register.fullname;
            },

            set(val) {
                this.setFullname(val);
            }
        },

        password: {
            get() {
                return this.$store.state.register.password;
            },

            set(val) {
                this.setPassword(val);
            }
        },

        confirmPassword: {
            get() {
                return this.$store.state.register.confirmPassword;
            },

            set(val) {
                this.setConfirmPassword(val);
            }
        }
    },

    methods: {
        ...mapMutations("register", [
            "setAppProvider",
            "setFullname",
            "setPassword",
            "setConfirmPassword"
        ]),
        ...mapActions("register", ["createCompany", "getCountries"]),
        ...mapActions(["checkVatNumber"]),

        setAddressDetails(place) {
            this.isAddress = place.isAddress;
            this.companyDetails.address = place.address;
            this.companyDetails.zip = place.zip;
            this.companyDetails.lat = place.lat;
            this.companyDetails.lon = place.lon;
        }
    },

    mounted() {
        this.getCountries();
        this.$clearFocus();
        this.companyDetails.company_details.store_subscription_plan_id = localStorage.getItem(
            "subscriptionPlan"
        );
    },

    watch: {
        ["companyDetails.loyalty_details.name.en"](val) {
            if (this.changeNameElAuto) {
                this.companyDetails.loyalty_details.name.el = val;
            }

            if (this.changeNameItAuto) {
                this.companyDetails.loyalty_details.name.it = val;
            }
        },

        ["companyDetails.loyalty_details.name.el"](val) {
            if (val != this.companyDetails.loyalty_details.name.en) {
                this.changeNameElAuto = false;
            }
        },

        ["companyDetails.loyalty_details.name.it"](val) {
            if (val != this.companyDetails.loyalty_details.name.en) {
                this.changeNameItAuto = false;
            }
        },

        ["companyDetails.loyalty_details.description.en"](val) {
            if (this.changeDescriptionElAuto) {
                this.companyDetails.loyalty_details.description.el = val;
            }

            if (this.changeDescriptionItAuto) {
                this.companyDetails.loyalty_details.description.it = val;
            }
        },

        ["companyDetails.loyalty_details.description.el"](val) {
            if (val != this.companyDetails.loyalty_details.description.en) {
                this.changeDescriptionAuto = false;
            }
        },

        ["companyDetails.loyalty_details.description.it"](val) {
            if (val != this.companyDetails.loyalty_details.description.en) {
                this.changeDescriptionItAuto = false;
            }
        },

        ["companyDetails.company_details.country_id"](val) {
            if (val) {
                this.companyDetails.company_details.vat_country_id = val;
                this.companyDetails.loyalty_details.country_id = val;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.back-to-plan {
    color: #888;
    font-size: 0.95rem;
    cursor: pointer;
    transition: color 0.2s, font-weight 0.2s, text-decoration 0.2s;

    &:hover {
        color: black;
        font-weight: 500;
        text-decoration: underline;
    }
}
</style>
